webpackJsonp([1],{

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(109);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(21);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(69);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(70);

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__(44);

var _hoc = __webpack_require__(294);

var _eventBus = __webpack_require__(112);

var _item = __webpack_require__(501);

var _item2 = _interopRequireDefault(_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstrumentList = function (_Component) {
    (0, _inherits3.default)(InstrumentList, _Component);

    function InstrumentList(props) {
        (0, _classCallCheck3.default)(this, InstrumentList);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InstrumentList.__proto__ || Object.getPrototypeOf(InstrumentList)).call(this, props));

        _this.state = {
            instruments: props.instruments
        };
        return _this;
    }

    (0, _createClass3.default)(InstrumentList, [{
        key: 'updateInstrument',
        value: function updateInstrument(quote) {
            var instruments = this.state.instruments;

            var updated = 0;
            instruments = instruments.map(function (instrument) {
                if (quote.s === instrument.symbol && Number(instrument.value) !== Number(quote.r)) {
                    instrument.value = quote.r;
                    instrument.percentChange = (instrument.value * 100 / instrument.close - 100).toFixed(2);
                    updated++;
                }

                return instrument;
            });

            if (updated > 0) {
                this.setState({ instruments: instruments });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.bus.take(_eventBus.EVENT_QUOTES, function (q) {
                _this2.updateInstrument(q);
            });
        }
    }, {
        key: 'render',
        value: function render(_ref, _ref2) {
            var theme = _ref.theme;
            var _ref2$instruments = _ref2.instruments,
                instruments = _ref2$instruments === undefined ? [] : _ref2$instruments;

            return (0, _preact.h)(
                'div',
                { className: theme.table, 'data-widget': 'list' },
                instruments.map(function (instrument, index) {
                    return (0, _preact.h)(_item2.default, { instrument: (0, _extends3.default)({}, instrument), className: index % 2 === 0 ? theme.odd : null });
                })
            );
        }
    }]);
    return InstrumentList;
}(_preact.Component);

exports.default = (0, _hoc.BusHoC)((0, _hoc.ThemeHoC)(InstrumentList));

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(108);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(111);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__(308);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _getTypes = __webpack_require__(309);

var _getTypes2 = _interopRequireDefault(_getTypes);

var _getContentRect = __webpack_require__(310);

var _getContentRect2 = _interopRequireDefault(_getContentRect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withContentRect(types) {
  return function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        }, _this.measure = function (entries) {
          var contentRect = (0, _getContentRect2.default)(_this._node, types || (0, _getTypes2.default)(_this.props));

          if (entries) {
            contentRect.entry = entries[0].contentRect;
          }

          _this.setState({ contentRect: contentRect });

          if (typeof _this.props.onResize === 'function') {
            _this.props.onResize(contentRect);
          }
        }, _this._handleRef = function (node) {
          if (_this._resizeObserver) {
            if (node) {
              _this._resizeObserver.observe(node);
            } else {
              _this._resizeObserver.disconnect(_this._node);
            }
          }
          _this._node = node;

          if (typeof _this.props.innerRef === 'function') {
            _this.props.innerRef(node);
          }
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(_class, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          this._resizeObserver = new _resizeObserverPolyfill2.default(this.measure);
        }
      }, {
        key: 'render',
        value: function render() {
          var _props = this.props,
              innerRef = _props.innerRef,
              onResize = _props.onResize,
              props = _objectWithoutProperties(_props, ['innerRef', 'onResize']);

          return (0, _react.createElement)(WrappedComponent, _extends({}, props, {
            measureRef: this._handleRef,
            measure: this.measure,
            contentRect: this.state.contentRect
          }));
        }
      }]);

      return _class;
    }(_react.Component), _class.propTypes = {
      client: _propTypes2.default.bool,
      offset: _propTypes2.default.bool,
      scroll: _propTypes2.default.bool,
      bounds: _propTypes2.default.bool,
      margin: _propTypes2.default.bool,
      innerRef: _propTypes2.default.func,
      onResize: _propTypes2.default.func,
      children: _propTypes2.default.func
    }, _temp2;
  };
}

exports.default = withContentRect;
module.exports = exports['default'];

/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.I18nHoc = exports.BusHoC = exports.ThemeHoC = undefined;

var _theme = __webpack_require__(313);

var _theme2 = _interopRequireDefault(_theme);

var _bus = __webpack_require__(314);

var _bus2 = _interopRequireDefault(_bus);

var _i18n = __webpack_require__(315);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ThemeHoC = _theme2.default;
exports.BusHoC = _bus2.default;
exports.I18nHoc = _i18n2.default;

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withContentRect = exports.default = undefined;

var _Measure = __webpack_require__(307);

var _Measure2 = _interopRequireDefault(_Measure);

var _withContentRect = __webpack_require__(293);

var _withContentRect2 = _interopRequireDefault(_withContentRect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Measure2.default;
exports.withContentRect = _withContentRect2.default;

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(108);

var _react2 = _interopRequireDefault(_react);

var _withContentRect = __webpack_require__(293);

var _withContentRect2 = _interopRequireDefault(_withContentRect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Measure(_ref) {
  var measure = _ref.measure,
      measureRef = _ref.measureRef,
      contentRect = _ref.contentRect,
      children = _ref.children;

  return children({ measure: measure, measureRef: measureRef, contentRect: contentRect });
}

exports.default = (0, _withContentRect2.default)()(Measure);
module.exports = exports['default'];

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: { configurable: true } };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            var this$1 = this;
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }

    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }

    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }

    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */


/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */


/**
 * Keeps reference to the instance of MutationObserver.
 *
 * @private {MutationObserver}
 */

/**
 * Indicates whether DOM listeners have been added.
 *
 * @private {boolean}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;

    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [], len = arguments.length - 1;
    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */


/**
 * Reference to the last observed content rectangle.
 *
 * @private {DOMRectInit}
 */


/**
 * Broadcasted width of content rectangle.
 *
 * @type {number}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */


/**
 * Registry of the ResizeObservation instances.
 *
 * @private {Map<Element, ResizeObservation>}
 */


/**
 * Public ResizeObserver instance which will be passed to the callback
 * function and used as a value of it's "this" binding.
 *
 * @private {ResizeObserver}
 */

/**
 * Collection of resize observations that have detected changes in dimensions
 * of elements.
 *
 * @private {Array<ResizeObservation>}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = function(callback) {
    if (!(this instanceof ResizeObserver)) {
        throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }

    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(45)))

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTypes;
var types = ['client', 'offset', 'scroll', 'bounds', 'margin'];

function getTypes(props) {
  var allowedTypes = [];
  types.forEach(function (type) {
    if (props[type]) {
      allowedTypes.push(type);
    }
  });
  return allowedTypes;
}
module.exports = exports['default'];

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getContentRect(node, types) {
  var calculations = {};

  if (types.indexOf('client') > -1) {
    calculations.client = {
      top: node.clientTop,
      left: node.clientLeft,
      width: node.clientWidth,
      height: node.clientHeight
    };
  }

  if (types.indexOf('offset') > -1) {
    calculations.offset = {
      top: node.offsetTop,
      left: node.offsetLeft,
      width: node.offsetWidth,
      height: node.offsetHeight
    };
  }

  if (types.indexOf('scroll') > -1) {
    calculations.scroll = {
      top: node.scrollTop,
      left: node.scrollLeft,
      width: node.scrollWidth,
      height: node.scrollHeight
    };
  }

  if (types.indexOf('bounds') > -1) {
    var rect = node.getBoundingClientRect();
    calculations.bounds = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.width,
      height: rect.height
    };
  }

  if (types.indexOf('margin') > -1) {
    var styles = getComputedStyle(node);
    calculations.margin = {
      top: parseInt(styles.marginTop),
      right: parseInt(styles.marginRight),
      bottom: parseInt(styles.marginBottom),
      left: parseInt(styles.marginLeft)
    };
  }

  return calculations;
}

exports.default = getContentRect;
module.exports = exports['default'];

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _numbers = __webpack_require__(312);

Object.defineProperty(exports, 'formatNumber', {
  enumerable: true,
  get: function get() {
    return _numbers.format;
  }
});

var _instruments = __webpack_require__(110);

Object.defineProperty(exports, 'getLbxLink', {
  enumerable: true,
  get: function get() {
    return _instruments.getLbxLink;
  }
});
Object.defineProperty(exports, 'getInstrumentLink', {
  enumerable: true,
  get: function get() {
    return _instruments.getInstrumentLink;
  }
});
Object.defineProperty(exports, 'getInstrumentTradeLink', {
  enumerable: true,
  get: function get() {
    return _instruments.getInstrumentTradeLink;
  }
});

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.format = format;
function format(number) {
    var precisionNumbers = (number + '').split('.')[1];
    var precision = precisionNumbers ? precisionNumbers.length : 0;
    return new Intl.NumberFormat([], { minimumFractionDigits: precision }).format(number).replace(/-/, '−');
}

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(109);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(21);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(69);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(70);

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__(44);

var _react = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemeHoC = function ThemeHoC(WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
        (0, _inherits3.default)(ThemeComponent, _Component);

        function ThemeComponent() {
            (0, _classCallCheck3.default)(this, ThemeComponent);
            return (0, _possibleConstructorReturn3.default)(this, (ThemeComponent.__proto__ || Object.getPrototypeOf(ThemeComponent)).apply(this, arguments));
        }

        (0, _createClass3.default)(ThemeComponent, [{
            key: 'render',
            value: function render() {
                var theme = this.context.theme;

                return (0, _preact.h)(WrappedComponent, (0, _extends3.default)({}, this.props, { theme: theme }));
            }
        }]);
        return ThemeComponent;
    }(_react.Component), _class.contextTypes = {
        theme: _react.PropTypes.object.isRequired
    }, _temp;
};
exports.default = ThemeHoC;

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(109);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(21);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(69);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(70);

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__(44);

var _react = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BusHoC = function BusHoC(WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
        (0, _inherits3.default)(BusComponent, _Component);

        function BusComponent() {
            (0, _classCallCheck3.default)(this, BusComponent);
            return (0, _possibleConstructorReturn3.default)(this, (BusComponent.__proto__ || Object.getPrototypeOf(BusComponent)).apply(this, arguments));
        }

        (0, _createClass3.default)(BusComponent, [{
            key: 'render',
            value: function render() {
                var bus = this.context.bus;

                return (0, _preact.h)(WrappedComponent, (0, _extends3.default)({}, this.props, { bus: bus }));
            }
        }]);
        return BusComponent;
    }(_react.Component), _class.contextTypes = {
        bus: _react.PropTypes.object.isRequired
    }, _temp;
};
exports.default = BusHoC;

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(109);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(21);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(69);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(70);

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__(44);

var _react = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var I18nHoC = function I18nHoC(WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_Component) {
        (0, _inherits3.default)(I18nComponent, _Component);

        function I18nComponent() {
            (0, _classCallCheck3.default)(this, I18nComponent);
            return (0, _possibleConstructorReturn3.default)(this, (I18nComponent.__proto__ || Object.getPrototypeOf(I18nComponent)).apply(this, arguments));
        }

        (0, _createClass3.default)(I18nComponent, [{
            key: 'render',
            value: function render() {
                var i18n = this.context.i18n;

                return (0, _preact.h)(WrappedComponent, (0, _extends3.default)({}, this.props, { I18n: i18n }));
            }
        }]);
        return I18nComponent;
    }(_react.Component), _class.contextTypes = {
        i18n: _react.PropTypes.object.isRequired
    }, _temp;
};
exports.default = I18nHoC;

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InstrumentItem = undefined;

var _classCallCheck2 = __webpack_require__(20);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(21);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(69);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(70);

var _inherits3 = _interopRequireDefault(_inherits2);

var _preact = __webpack_require__(44);

var _reactMeasure = __webpack_require__(298);

var _reactMeasure2 = _interopRequireDefault(_reactMeasure);

var _utils = __webpack_require__(311);

var _hoc = __webpack_require__(294);

var _style = __webpack_require__(502);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstrumentItem = exports.InstrumentItem = function (_Component) {
    (0, _inherits3.default)(InstrumentItem, _Component);

    function InstrumentItem(props) {
        (0, _classCallCheck3.default)(this, InstrumentItem);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InstrumentItem.__proto__ || Object.getPrototypeOf(InstrumentItem)).call(this, props));

        _this.state = {
            dimensions: {
                width: -1,
                height: -1
            }
        };
        return _this;
    }

    (0, _createClass3.default)(InstrumentItem, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            var value = this.props.instrument.value;

            var nextValue = nextProps.instrument.value;
            var theme = this.props.theme;


            this.tickClass = value === nextValue ? '' : value > nextValue ? theme['tickNeg'] : theme['tickPos'];

            return value !== nextValue || this.state.dimensions.width !== nextState.dimensions.width;
        }
    }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate() {
            var _this2 = this;

            var theme = this.props.theme;

            if (this.tickClass.length && this.tickerContainer) {
                window.requestAnimationFrame(function (t) {
                    var tickClass = _this2.tickClass;
                    _this2.tickerContainer.classList.remove(theme['tickPos']);
                    _this2.tickerContainer.classList.remove(theme['tickNeg']);
                    window.requestAnimationFrame(function (t) {
                        if (_this2.tickerContainer && tickClass) _this2.tickerContainer.classList.add(tickClass);
                    });
                });
            }
        }
    }, {
        key: 'render',
        value: function render(_ref) {
            var _this3 = this;

            var instrument = _ref.instrument,
                className = _ref.className,
                theme = _ref.theme,
                I18n = _ref.I18n;
            var alias = instrument.alias,
                value = instrument.value,
                percentChange = instrument.percentChange;
            var width = this.state.dimensions.width;


            var rowrClassName = [_style2.default.row, theme.tableRow];
            var isMobile = !window.matchMedia('(min-width: 480px)').matches;

            if ((width >= 480 || width === -1 || width === 0) && !isMobile) {
                rowrClassName.push(_style2.default.tablet);
            }

            if (className) {
                rowrClassName.push(className);
            }

            return (0, _preact.h)(
                _reactMeasure2.default,
                {
                    bounds: true,
                    onResize: function onResize(contentRect) {
                        _this3.setState({ dimensions: contentRect.bounds });
                    }
                },
                function (_ref2) {
                    var measureRef = _ref2.measureRef;
                    return (0, _preact.h)(
                        'div',
                        { className: rowrClassName.join(' '), ref: measureRef },
                        (0, _preact.h)(
                            'div',
                            { className: _style2.default.name, 'data-section': 'name' },
                            (0, _preact.h)(
                                'a',
                                {
                                    href: (0, _utils.getInstrumentLink)(instrument),
                                    title: alias,
                                    style: { color: theme.textColor }
                                },
                                alias
                            )
                        ),
                        (0, _preact.h)(
                            'div',
                            { className: '' + _style2.default.values, 'data-section': 'values' },
                            (0, _preact.h)(
                                'div',
                                {
                                    className: _style2.default.value,
                                    'data-section': 'value'
                                },
                                (0, _preact.h)(
                                    'span',
                                    {
                                        ref: function ref(elm) {
                                            _this3.tickerContainer = elm;
                                        }
                                    },
                                    (0, _utils.formatNumber)(value)
                                )
                            ),
                            (0, _preact.h)(
                                'div',
                                {
                                    'data-section': 'percent',
                                    className: percentChange > 0 ? _style2.default.precent + ' ' + theme.colorPositive : _style2.default.precent + ' ' + theme.colorNegative
                                },
                                (0, _preact.h)(
                                    'span',
                                    null,
                                    (0, _utils.formatNumber)(percentChange),
                                    '%'
                                )
                            )
                        ),
                        (0, _preact.h)(
                            'div',
                            { className: _style2.default.buttons, 'data-section': 'buttons' },
                            (0, _preact.h)(
                                'a',
                                {
                                    'data-button': 'buy',
                                    href: (0, _utils.getInstrumentTradeLink)(instrument),
                                    target: '_blank',
                                    rel: 'noopener',
                                    className: theme.btn + ' ' + theme.btnUp + ' ' + theme.btnSmall },
                                I18n.t("Buy")
                            ),
                            (0, _preact.h)(
                                'a',
                                {
                                    'data-button': 'sell',
                                    href: (0, _utils.getInstrumentTradeLink)(instrument),
                                    target: '_blank',
                                    rel: 'noopener',
                                    className: theme.btn + ' ' + theme.btnDown + ' ' + theme.btnSmall },
                                I18n.t("Sell")
                            )
                        )
                    );
                }
            );
        }
    }]);
    return InstrumentItem;
}(_preact.Component);

exports.default = (0, _hoc.ThemeHoC)((0, _hoc.I18nHoc)(InstrumentItem));

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(503);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(33)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--0-1!../../../../node_modules/postcss-loader/lib/index.js!./style.css", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--0-1!../../../../node_modules/postcss-loader/lib/index.js!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(true);
// imports
exports.i(__webpack_require__(1), undefined);

// module
exports.push([module.i, ".style__row___3vaBm {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: row wrap;\n            flex-flow: row wrap;\n    -webkit-box-align:center;\n        -ms-flex-align:center;\n            align-items:center;\n    padding: 8px 20px;\n}\n\n.style__row___3vaBm .style__name___2NlBN a {\n    text-decoration: none;\n}\n\n.style__row___3vaBm .style__name___2NlBN {\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    font-weight: " + __webpack_require__(1).locals["fontWeightStrong"] + ";\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.style__row___3vaBm .style__values___RPPSB {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    text-align: left;\n    margin: 10px 0;\n}\n\n.style__row___3vaBm .style__values___RPPSB .style__precent___19MPM {\n    padding-left: 15px; \n}\n\n.style__values___RPPSB > div {\n    -ms-flex-preferred-size: 50%;\n        flex-basis: 50%;\n    line-height: 1.1;\n}\n\n.style__values___RPPSB > div > span {\n    padding: 10px;\n}\n\n.style__buttons___16mKJ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n}\n\n.style__buttons___16mKJ a {\n    -ms-flex-preferred-size: 50%;\n        flex-basis: 50%;\n}\n\n.style__buttons___16mKJ a:first-child {\n    margin-right: 14px;\n}\n\n.style__tablet___3X-Ej.style__row___3vaBm {\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n}\n\n.style__tablet___3X-Ej.style__row___3vaBm .style__name___2NlBN {\n    -ms-flex-preferred-size: 37%;\n        flex-basis: 37%;   \n}\n\n.style__tablet___3X-Ej.style__row___3vaBm .style__values___RPPSB {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    margin: 0;\n}\n\n.style__tablet___3X-Ej.style__row___3vaBm .style__values___RPPSB > div {\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    line-height: 1.1;\n}\n\n.style__tablet___3X-Ej.style__row___3vaBm .style__buttons___16mKJ {\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n}\n\n.style__tablet___3X-Ej .style__buttons___16mKJ a {\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n}\n\n.style__tablet___3X-Ej.style__row___3vaBm .style__values___RPPSB .style__precent___19MPM {\n    padding-left: 0px; \n}", "", {"version":3,"sources":["/builds/web/static/live-quotes/src/components/list/item/style.css"],"names":[],"mappings":"AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,+BAA+B;IAC/B,8BAA8B;QAC1B,wBAAwB;YACpB,oBAAoB;IAC5B,yBAAyB;QACrB,sBAAsB;YAClB,mBAAmB;IAC3B,kBAAkB;CACrB;;AAED;IACI,sBAAsB;CACzB;;AAED;IACI,8BAA8B;QAC1B,iBAAiB;IACrB,yCAA8B;IAC9B,wBAAwB;IACxB,oBAAoB;IACpB,iBAAiB;CACpB;;AAED;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,8BAA8B;QAC1B,iBAAiB;IACrB,iBAAiB;IACjB,eAAe;CAClB;;AAED;IACI,mBAAmB;CACtB;;AAED;IACI,6BAA6B;QACzB,gBAAgB;IACpB,iBAAiB;CACpB;;AAED;IACI,cAAc;CACjB;;AAED;IACI,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;IACd,uBAAuB;QACnB,oBAAoB;YAChB,sBAAsB;IAC9B,8BAA8B;QAC1B,iBAAiB;CACxB;;AAED;IACI,6BAA6B;QACzB,gBAAgB;CACvB;;AAED;IACI,mBAAmB;CACtB;;AAED;IACI,sBAAsB;QAClB,kBAAkB;CACzB;;AAED;IACI,6BAA6B;QACzB,gBAAgB;CACvB;;AAED;IACI,oBAAoB;QAChB,qBAAqB;YACjB,aAAa;IACrB,8BAA8B;QAC1B,iBAAiB;IACrB,qBAAqB;QACjB,eAAe;IACnB,UAAU;CACb;;AAED;IACI,8BAA8B;QAC1B,iBAAiB;IACrB,oBAAoB;QAChB,qBAAqB;YACjB,aAAa;IACrB,qBAAqB;QACjB,eAAe;IACnB,iBAAiB;CACpB;;AAED;IACI,8BAA8B;QAC1B,iBAAiB;IACrB,uBAAuB;QACnB,oBAAoB;YAChB,sBAAsB;IAC9B,sBAAsB;QAClB,mBAAmB;YACf,0BAA0B;IAClC,qBAAqB;QACjB,eAAe;CACtB;;AAED;IACI,8BAA8B;QAC1B,iBAAiB;CACxB;;AAED;IACI,kBAAkB;CACrB","file":"style.css","sourcesContent":["@value fontWeightStrong from '@/styles/typography.css';\n\n.row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-flow: row wrap;\n            flex-flow: row wrap;\n    -webkit-box-align:center;\n        -ms-flex-align:center;\n            align-items:center;\n    padding: 8px 20px;\n}\n\n.row .name a {\n    text-decoration: none;\n}\n\n.row .name {\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    font-weight: fontWeightStrong;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.row .values {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n    text-align: left;\n    margin: 10px 0;\n}\n\n.row .values .precent {\n    padding-left: 15px; \n}\n\n.values > div {\n    -ms-flex-preferred-size: 50%;\n        flex-basis: 50%;\n    line-height: 1.1;\n}\n\n.values > div > span {\n    padding: 10px;\n}\n\n.buttons {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    -ms-flex-preferred-size: 100%;\n        flex-basis: 100%;\n}\n\n.buttons a {\n    -ms-flex-preferred-size: 50%;\n        flex-basis: 50%;\n}\n\n.buttons a:first-child {\n    margin-right: 14px;\n}\n\n.tablet.row {\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n}\n\n.tablet.row .name {\n    -ms-flex-preferred-size: 37%;\n        flex-basis: 37%;   \n}\n\n.tablet.row .values {\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    margin: 0;\n}\n\n.tablet.row .values > div {\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    -webkit-box-flex: 1;\n        -ms-flex-positive: 1;\n            flex-grow: 1;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    line-height: 1.1;\n}\n\n.tablet.row .buttons {\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n    -webkit-box-align: end;\n        -ms-flex-align: end;\n            align-items: flex-end;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n}\n\n.tablet .buttons a {\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n}\n\n.tablet.row .values .precent {\n    padding-left: 0px; \n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"fontWeightStrong": "" + __webpack_require__(1).locals["fontWeightStrong"] + "",
	"row": "style__row___3vaBm",
	"name": "style__name___2NlBN",
	"values": "style__values___RPPSB",
	"precent": "style__precent___19MPM",
	"buttons": "style__buttons___16mKJ",
	"tablet": "style__tablet___3X-Ej"
};

/***/ })

});


// WEBPACK FOOTER //
// 1.bundle-v1.4.3.js